// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"c81273cc","140":"fdaef8b5","447":"addbf20c","742":"d9639f2d","821":"fcdf002e","993":"5d043515"}[chunkId] + ".css";
};